
import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";

interface BasicInformationData {
  client_name: string;
  firstname?: string;
  lastname?: string;
  preferred_name: string;
  client_id: string;
  dob: string;
  gender: string;
  address: string;
  date_started: string;
  date_completed: string;
  phone_number: string;
  email_address: string;
  tags: string[];
}

@Component
export default class BasicInformation extends Vue {
  @Prop({ required: true }) readonly data!: BasicInformationData;

  formmatedDate(date){
    if(date){
     return moment(date).format("DD/MM/YYYY");
    }
    return 'N/A';
  }

  getFullName(data: BasicInformationData): string {
    if (data.firstname && data.lastname) {
      return `${data.firstname} ${data.lastname}`;
    }
    return data.client_name || 'N/A';
  }

}
